import { Component, Show, createSignal } from "solid-js";
import { Button } from "./Button";

export interface UpdateNotificationProps {
  visible: boolean;
  onReload: () => void;
}

export const UpdateNotification: Component<UpdateNotificationProps> = (
  props,
) => {
  const [dismissed, setDismissed] = createSignal(false);

  const shouldShow = () => props.visible && !dismissed();

  return (
    <Show when={shouldShow()}>
      <div
        role="status"
        aria-live="polite"
        class="fixed right-4 bottom-[calc(var(--footer-height)+1rem)] z-[var(--z-toast)] w-80 max-w-[calc(100vw-2rem)] bg-surface border border-line-strong rounded animate-[slide-up_300ms_ease-out]"
      >
        <div class="flex items-start gap-3 p-4">
          {/* Icon */}
          <div class="shrink-0 mt-0.5">
            <div class="w-8 h-8 rounded-full bg-signal-blue-tint flex items-center justify-center">
              <svg
                class="w-4 h-4 text-signal-blue"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                />
              </svg>
            </div>
          </div>

          {/* Content */}
          <div class="flex-1 min-w-0">
            <p class="text-sm font-medium text-ink">
              A new version is available
            </p>
            <p class="mt-1 text-sm text-ink-2">
              Reload to get the latest improvements.
            </p>
            <Button size="sm" class="mt-3" onClick={() => props.onReload()}>
              Reload now
            </Button>
          </div>

          {/* Dismiss button */}
          <button
            type="button"
            class="shrink-0 p-1 text-ink-3 hover:text-ink rounded-sm transition-colors focus-ring"
            onClick={() => setDismissed(true)}
            aria-label="Dismiss update notification"
          >
            <svg
              class="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
      </div>
    </Show>
  );
};
